(function () {
  'use strict';

  // Eigentümer des ATC-Button-Zustands (Label, Preis-Summe, disabled) und der
  // Quantity-Stepper-Bindung. Der Inline-Variant-Change-Handler in
  // snippet-product-buy-box-trautis pflegt nur noch Preisblock + Grundpreis;
  // notify-oos togglet ausschließlich [hidden] — kein Überschneidungs-Konflikt.

  // Muss das SSR-Format des `money`-Filters treffen (€-Präfix, Komma-Dezimal,
  // Punkt-Tausender), sonst springt das Format beim ersten Klick.
  function formatMoney(cents) {
    var n = Number(cents);
    if (cents === null || cents === undefined || !isFinite(n)) return null;
    n = Math.round(n);
    var euros = Math.floor(n / 100);
    var ct = String(n % 100);
    if (ct.length < 2) ct = '0' + ct;
    var intStr = String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + intStr + ',' + ct;
  }

  function clampQty(raw) {
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 1) return 1;
    return n;
  }

  function computeTotalCents(priceCents, qty) {
    var p = Number(priceCents);
    if (priceCents === null || priceCents === undefined || !isFinite(p)) return null;
    return Math.round(p) * clampQty(qty);
  }

  function resolveAtcState(variant, qty) {
    if (!variant) return null;
    if (!variant.available) return { available: false, priceText: null };
    var total = computeTotalCents(variant.price, qty);
    return { available: true, priceText: total === null ? null : formatMoney(total) };
  }

  function getProductJSON(root) {
    var s = root.querySelector('script[type="application/json"][data-product-json]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function bind(root) {
    if (root.dataset.qtyAtcBound) return;
    var buybox = root.querySelector('[data-product-form]');
    if (!buybox) return;
    var qtyInput = buybox.querySelector('input[name="quantity"]');
    var atcBtn = buybox.querySelector('[data-atc-button]');
    var atcLabel = buybox.querySelector('[data-atc-label]');
    if (!qtyInput || !atcBtn || !atcLabel) return;
    root.dataset.qtyAtcBound = '1';

    var expressQty = buybox.querySelector('[data-express-qty]');

    var currentVariant = null;
    var productJSON = getProductJSON(root);
    var idInput = buybox.querySelector('form input[name="id"]');
    if (productJSON && productJSON.variants && idInput) {
      var vid = parseInt(idInput.value, 10);
      for (var i = 0; i < productJSON.variants.length; i++) {
        if (productJSON.variants[i].id === vid) { currentVariant = productJSON.variants[i]; break; }
      }
    }

    function render() {
      var qty = clampQty(qtyInput.value);
      if (expressQty) expressQty.value = qty;
      var state = resolveAtcState(currentVariant, qty);
      if (!state) return;
      if (state.available) {
        atcBtn.removeAttribute('disabled');
        var span = document.createElement('span');
        span.setAttribute('data-atc-price', '');
        span.textContent = state.priceText;
        atcLabel.replaceChildren(document.createTextNode('In den Warenkorb · '), span);
      } else {
        atcBtn.setAttribute('disabled', '');
        atcLabel.replaceChildren(document.createTextNode('Aktuell nicht verfügbar'));
      }
    }

    buybox.querySelectorAll('[data-qty-decrement]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = clampQty(qtyInput.value) - 1;
        qtyInput.value = v < 1 ? 1 : v;
        render();
      });
    });
    buybox.querySelectorAll('[data-qty-increment]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = clampQty(qtyInput.value) + 1;
        render();
      });
    });
    // 'input': Preis live nachziehen, Feld aber nicht umschreiben (stört Tippen);
    // 'change' (blur): Feldwert normalisieren.
    qtyInput.addEventListener('input', render);
    qtyInput.addEventListener('change', function () {
      qtyInput.value = clampQty(qtyInput.value);
      render();
    });

    root.addEventListener('trautis:variant-change', function (e) {
      if (e.detail && e.detail.variant) currentVariant = e.detail.variant;
      render();
    });

    // Initialer Sync (SSR rendert bereits Summe × Default-Menge; hier nur
    // Express-Qty angleichen und Zustand idempotent bestätigen).
    render();
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(bind);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  // Exposed for test harness only; no runtime callers.
  window.TrautisQtyAtc = {
    formatMoney: formatMoney,
    clampQty: clampQty,
    computeTotalCents: computeTotalCents,
    resolveAtcState: resolveAtcState
  };
})();

// Node.js / test harness export
if (typeof module !== 'undefined' && module.exports) {
  module.exports = (typeof window !== 'undefined' && window.TrautisQtyAtc) || {
    formatMoney: function () { return null; },
    clampQty: function () { return 1; },
    computeTotalCents: function () { return null; },
    resolveAtcState: function () { return null; }
  };
}
